import clsx from 'clsx';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { getSocialMediaFromLink, SocialMedia } from './mappings';

interface Props {
  link?: string;
  socialMedia?: SocialMedia;
  className?: string;
}

export default function SocialMediaIcon({ link, socialMedia, className }: Props) {
  if (!link && !socialMedia) return null;

  const socialMediaIcons = {
    [SocialMedia.FACEBOOK]: toAbsoluteUrl('/media/svg/social-logos/png/facebook.png'),
    [SocialMedia.MESSENGER]: toAbsoluteUrl('/media/svg/social-logos/png/messenger.png'),
    [SocialMedia.INSTAGRAM]: toAbsoluteUrl('/media/svg/social-logos/png/instagram.png'),
    [SocialMedia.WHATSAPP]: toAbsoluteUrl('/media/svg/social-logos/png/whatsapp.png'),
    [SocialMedia.X]: toAbsoluteUrl('/media/svg/social-logos/png/x.png'),
    [SocialMedia.LINKEDIN]: toAbsoluteUrl('/media/svg/social-logos/png/linkedin.png'),
    [SocialMedia.YOUTUBE]: toAbsoluteUrl('/media/svg/social-logos/png/youtube.png'),
    [SocialMedia.PINTEREST]: toAbsoluteUrl('/media/svg/social-logos/png/pinterest.png'),
    [SocialMedia.REDDIT]: toAbsoluteUrl('/media/svg/social-logos/png/reddit.png'),
    [SocialMedia.SNAPCHAT]: toAbsoluteUrl('/media/svg/social-logos/png/snapchat.png'),
    [SocialMedia.THREADS]: toAbsoluteUrl('/media/svg/social-logos/png/threads.png'),
    [SocialMedia.MASTODON]: toAbsoluteUrl('/media/svg/social-logos/png/mastodon.png'),
    [SocialMedia.DISCORD]: toAbsoluteUrl('/media/svg/social-logos/png/discord.png'),
    [SocialMedia.FLICKR]: toAbsoluteUrl('/media/svg/social-logos/png/flickr.png'),
    [SocialMedia.TUMBLR]: toAbsoluteUrl('/media/svg/social-logos/png/tumblr.png'),
    [SocialMedia.LINE]: toAbsoluteUrl('/media/svg/social-logos/png/line.png'),
    [SocialMedia.TELEGRAM]: toAbsoluteUrl('/media/svg/social-logos/png/telegram.png'),
    [SocialMedia.TIKTOK]: toAbsoluteUrl('/media/svg/social-logos/png/tiktok.png'),
    [SocialMedia.WEIBO]: toAbsoluteUrl('/media/svg/social-logos/png/weibo.png'),
    [SocialMedia.WECHAT]: toAbsoluteUrl('/media/svg/social-logos/png/wechat.png'),
    [SocialMedia.QQ]: toAbsoluteUrl('/media/svg/social-logos/png/qq.png'),
    [SocialMedia.XIAOHONGSHU]: toAbsoluteUrl('/media/svg/social-logos/png/xiaohongshu.png'),
    [SocialMedia.TWITCH]: toAbsoluteUrl('/media/svg/social-logos/png/twitch.png'),
    [SocialMedia.BLUESKY]: toAbsoluteUrl('/media/svg/social-logos/png/bluesky.png'),
  };

  const media = socialMedia ?? getSocialMediaFromLink(link);
  const iconPath = socialMediaIcons[media] || '';

  return (
    iconPath && (
      <div className={clsx('', className)}>
        <img
          src={iconPath}
          alt={socialMedia}
          className='w-100 h-100'
          style={{
            padding: media === SocialMedia.X ? '1px' : '0',
          }}
        />
      </div>
    )
  );
}
